// ============================================================================
// HEBREW TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "אחדות",
    author: "מאת עמנואל",
    subtitle: "מעבר לגבולות, לקראת האחדות",
    description: "הרהור על האחדות בין אמונות ובני אדם",
    nav: {
      intro: "מבוא",
      religions: "דתות",
      common: "ערכים משותפים",
      humility: "ענווה"
    },
    intro: {
      emmanuelSays: "אני עמנואל, ואני אומר לכם:",
      ourBordersFromPast: "הגבולות שלנו מגיעים מהעבר",
      bordersDescription: "הם נולדו ממאות שנים של היסטוריה, סכסוכים, וירושות שהועברו כמו בולים שגורמים לנו לראות את העולם בצבעים שונים.",
      divisionWork: "הפילוג זו העבודה של השטן.",
      sharedHumanity: "אבל האנושות המשותפת שלנו עמוקה מכל גבול – היא החלק האלוהי שבכולנו.",
      revelationTitle: "📖 התגלות:",
      surprisedLearning: "הופתעתי וכך התחלתי ללמוד:",
      angelMichael: "המלאך מיכאל נמצא גם בנצרות, גם באסלאם וגם ביהדות.",
      jesusNames: "ישוע, עיסא, ישוע – שמות שונים, אותו האיש.",
      diverseTribes: "שבטים שונים, אותו אלוהים, נחשי פיתוי אותם, וכתבים מלאי אהבה.",
      sameRealities: "המציאויות האלה הן ממש אותו הדבר!",
      respectTitle: "🤝 כבוד:",
      respectFoundation: "אנחנו צריכים לכבד אחד את השני – זה היסוד של שלום וחיים טובים יותר יחד.",
      understandingProcess: "הבנה היא תהליך. למידה חשפה לי שהדברים שחשבתי שהם כל כך שונים באמת מכוונים לאותה מקום.",
      whatBindsUs: "מה שמקשר אותנו",
      seekingRelation: "כולנו מחפשים יחס עם הבורא, פועלים בדרכים שונות, במגוון של כתבים, אבל עם אותן נקודות מסתוריות לגעת בו.",
      loveOfGod: "באיזושהי דרך, יש דבר כזה אחד – האהבה של אלוהים והרצון שלנו למצוא אותו.",
      universalLink: "זה הקישור האוניברסלי שלנו.",
      inclusionTitle: "🌍 הכללה:",
      vastInclusion: "ההכללה של אלוהים רחבה ביותר.",
      respectDifferences: "אני מאמין שאלוהים מכבד את ההבדלים שלנו ומקבל את כל מי שפועל בכנות ובאהבה, גם אם הם מדברים אליו בשמות שונים או בשפות שונות.",
      jesusCommand: "ישוע מצווה אותנו לאהוב את הזולת, מבלי להסתכל על הרקע שלו.",
      communitySpirit: "💭 רוח הקהילה:",
      communityTerror: "קהילת האימה נלחמת במי שעושה ומראה שלום.",
      pridePolitics: "הגאווה שלהם היא פוליטית, והם לא מוכנים לראות את האנושיות המשותפה שלנו.",
      prideQuotes: "אבל הכתבים מזהירים:",
      watchHeart: "שמור על הלב שלך מעל לכל משמר, כי ממנו מוצא החיים.",
      refuseDivision: "סרב להשתתף בפילוג הזה.",
      freedomTitle: "🕊️ חופש:",
      freedomOthers: "החופש של אחרים לבחור את הדרך שלהם צריך להיות מוגן.",
      defendFreedom: "אנחנו צריכים להגן על החופש של הכול – כולל אלה שלא חושבים כמונו.",
      changeHeartTitle: "❤️ שינוי הלב:",
      recognizeDecency: "הכר את ההגינות והחוכמה שבתוך כל מסורת.",
      changeYourself: "שינוי מתחיל בך. בחר לראות טוב, למרות שחשים לך להאמין שהכול חלקו רק.",
      beExample: "היה הדוגמה, מבלי שמצפים משהו בתמורה.",
      childrenPeaceTitle: "👶 ילדי השלום:",
      avoidPursuit: "תתרחק מאלה שרודפים אחרי שנאה.",
      peaceChoice: "השלום הוא בחירה שאתה עושה מדי יום.",
      discernTitle: "🔍 הבחנה:",
      manSpeaks: "האיש מדבר, אבל מה שקובע אותו הם מעשיו.",
      seeFruits: "ראה את הפירות – האם הם עוסקים בשלום או בהשמדה?",
      lookPeaceTitle: "👀 חפש שלום:",
      lookPeaceAll: "חפש שלום בכל מקום, מבלי הבדל.",
      godSpeaks: "אלוהים מדבר בצורות רבות.",
      watchWordsTitle: "⚠️ שמור על דבריך:",
      watchShares: "שמור מה שאתה משתף.",
      disqualify: "אל תפסול אנשים על סמך הפחדים ששתלו בתוכך.",
      wisdomMaturityTitle: "🌱 חוכמה ובשלות:",
      useScriptures: "השתמש בכתבים כדי לכבד, לא כדי להרוס.",
      hateSin: "שנאת החטא לא אומרת שונאים את האדם.",
      separateActs: "הפרד את המעשים מהאישיות.",
      compassionNature: "החמלה היא טבע של אמת.",
      denounceLeadersTitle: "📢 הוקע מנהיגים:",
      watchLeaders: "שמור על מנהיגים שמשתמשים באלוהים כדי לפלג ולכפות.",
      noJustice: "אין צדק במקום שבו אין אהבה.",
      silenceComplicity: "שתיקה היא השתתפות."
    },
    religions: {
      title: "השוואת דתות",
      intro: "הנה איך דתות גדולות רואות מושגים משותפים:",
      theirGod: "האל שלהם",
      theGood: "הטוב",
      theEvil: "הרע",
      theAngels: "המלאכים",
      theUnity: "האחדות",
      values: "ערכים",
    commonGoal: "מטרה משותפת",
    seekingPeace: "כל הדתות חולקות מטרה משותפת: לחפש שלום, לקדם אהבה ולבנות עולם טוב יותר. מעבר להבדלים שלנו, כולנו מאוחדים במסע זה לחוכמה והרמוניה.",
      christianity: {
        name: "נצרות",
        godText: "האב, הבן (ישוע), רוח הקודש – שלושה באחד",
        goodText: "לעקוב אחרי ישוע, לאהוב את הזולת כמו את עצמך",
        evilText: "השטן, החטא, הפיתוי",
        angelsText: "מיכאל, גבריאל – שליחים של אלוהים",
        unityText: "תפילת ישוע: 'שיהיו אחד כמו שאנחנו אחד'",
        values: "אהבה, חסד, סליחה, השפלה, אמונה"
      },
      islam: {
        name: "אסלאם",
        godText: "אללה – יחיד ובלתי מתחלק",
        goodText: "לציית לאללה, להיות צדיק, לעשות צדקה",
        evilText: "איבליס (השטן), יצרים רעים",
        angelsText: "ג'יבריל (גבריאל), מיכאל – שליחים נאמנים",
        unityText: "כל המוסלמים הם אחים, האומה אחת",
        values: "צדק, חמלה, ענווה, נאמנות, תפילה"
      },
      judaism: {
        name: "יהדות",
        godText: "יהוה – אלוהי ישראל, יחיד ואחד",
        goodText: "לקיים את המצוות, לאהוב את ה', לפעול בצדק",
        evilText: "היצר הרע, הפיתוי, חטא",
        angelsText: "מיכאל, גבריאל – שליחי אלוהים",
        unityText: "ישראל כולו ערבים זה בזה, שמע ישראל",
        values: "תורה, צדקה, צדק, השכלה, קהילה"
      },
      hinduism: {
        name: "הינדואיזם",
        godText: "ברהמן – המציאות האולטימטיבית, המתבטאת בדרכים רבות (דווה/דווי)",
        goodText: "דרמה (חובה חיונית), אהימסה (אי-אלימות)",
        evilText: "מאיה (אשליה), קארמה שלילית",
        angelsText: "דבתות (אלים/שליחים מרובים), כל אחד מופע של הברהמן",
        unityText: "'ואסודייבה קוטומבקם' – העולם כולו משפחה אחת",
        values: "אהימסה, דרמה, קארמה, מוקשה (שחרור), מדיטציה"
      },
      buddhism: {
        name: "בודהיזם",
        godText: "אין אלוהים אישי, אבל אלוהות אוניברסלית (דרמה, אמת)",
        goodText: "לעקוב אחר השביל האצילי של שמונה, חמלה (קרונה)",
        evilText: "בורות, תאווה, שנאה – גורמי סבל",
        angelsText: "בודהיסטוות – יצורים נאורים שעוזרים לאחרים",
        unityText: "האינטרקונקטדות של כל היצורים – כל הדברים אחד",
        values: "חמלה, מיינדפולנס, אי-אלימות, סבלנות, מדיטציה"
      }
    },
    common: {
      title: "ערכים משותפים",
      intro: "כשאנחנו מסתכלים מקרוב, כל האמונות האלה חולקות מושגים מרכזיים:",
      goodTitle: "הטוב",
      goodDescription: "כל הדתות מעריכות צדק, אהבה, חמלה, ענווה, ושירות לאחרים.",
      goodExamples: "• לאהוב את הזולת (נצרות)\n• לפעול בצדקה (אסלאם)\n• לקיים את המצוות (יהדות)\n• דרמה ואהימסה (הינדואיזם)\n• חמלה ומיינדפולנס (בודהיזם)",
      evilTitle: "הרע",
      evilDescription: "כל האמונות מכירות בכוחות שמנסים להרחיק אותנו מהטוב.",
      evilExamples: "• השטן/איבליס (נצרות/אסלאם)\n• היצר הרע (יהדות)\n• מאיה (אשליה) וקארמה שלילית (הינדואיזם)\n• בורות ותאווה (בודהיזם)",
      angelsTitle: "המלאכים",
      angelsDescription: "שליחים או מתווכים רוחניים בין האלוהות לבני האדם.",
      angelsExamples: "• מיכאל, גבריאל (נצרות, אסלאם, יהדות)\n• דבתות (הינדואיזם)\n• בודהיסטוות (בודהיזם)",
      godTitle: "האל",
      godDescription: "כל המסורות מצביעות על מציאות אולטימטיבית – גם אם נקראת בשמות שונים.",
      godExamples: "• האב, הבן, רוח הקודש (נצרות)\n• אללה (אסלאם)\n• יהוה (יהדות)\n• ברהמן (הינדואיזם)\n• דרמה/אמת (בודהיזם)",
      relationTitle: "היחס",
      relationDescription: "כולנו מחפשים קשר עם הקודש, לחיות בהרמוניה עם האמת.",
      relationExamples: "• לעקוב אחרי ישוע (נצרות)\n• לציית לאללה (אסלאם)\n• לקיים את המצוות (יהדות)\n• להשיג מוקשה (הינדואיזם)\n• להגיע לנירוונה (בודהיזם)",
      inclusionTitle: "ההכללה",
      inclusionDescription: "כל דת קוראת לאחדות, לקהילה, ולכבוד ההבדלים.",
      inclusionExamples: "• 'שיהיו אחד' (נצרות)\n• 'האומה אחת' (אסלאם)\n• 'ישראל ערבים זה בזה' (יהדות)\n• 'העולם משפחה אחת' (הינדואיזם)\n• 'האינטרקונקטדות של כולם' (בודהיזם)",
      finalQuote: "הגבולות הם במוחות שלנו.",
      finalQuote2: "האחדות היא בליבות שלנו.",
      quoteAuthor: "- עמנואל"
    },
    humility: {
      title: "7 צעדים לענווה",
      intro: "אמת נמצאת בענווה. הנה שבעה צעדים למסע זה:",
      step: "צעד",
      action: "פעולה",
      step1Title: "הכר את המגבלות שלך",
      step1Description: "אנחנו לא יודעים הכול, וזה בסדר.",
      step1Action: "קבל שהבנתך לא מושלמת. אל תניח שאתה יודע יותר ממישהו אחר.",
      step2Title: "הקשב לאחרים",
      step2Description: "כל אדם נושא חלק מהאמת.",
      step2Action: "שמע לב לפני שתגיב. תן לאחרים לדבר מבלי להפריע.",
      step3Title: "הודה בטעויות שלך",
      step3Description: "טעויות הן חלק מהלמידה.",
      step3Action: "כשטעית, הודה בכך. התנצל, תקן, ולמד.",
      step4Title: "חפש את הטוב באחרים",
      step4Description: "בכל אדם יש דבר טוב, גם אם קשה למצוא.",
      step4Action: "תמקד את עצמך בתכונות החיוביות של אחרים במקום לבקר.",
      step5Title: "נסוג מהגאווה",
      step5Description: "הגאווה היא האויב של האחדות.",
      step5Action: "שים לב למחשבות גאוותניות – 'אני יותר טוב מהם' – ודחה אותן.",
      step6Title: "שרת בהשפלה",
      step6Description: "אהבה אמיתית משרתת מבלי לצפות תמורה.",
      step6Action: "עשה דברים טובים בשקט, מבלי לחפש כבוד או תשומת לב.",
      step7Title: "התפלל לחוכמה",
      step7Description: "חכמה אמיתית באה מאלוהים, לא מאיתנו.",
      step7Action: "בקש כל יום להבין את האמת טוב יותר ולאהוב טוב יותר.",
      discernFruits: "🔍 הבחן את הפירות",
      humanHeart: "הלב האנושי יכול לרמות, אבל המעשים שלו מגלים את האמת שלו.",
      lookGodLove: "חפש את אהבת אלוהים בכל אדם, גם אם הוא מאמין אחרת.",
      watchOurWords: "שמור על דברינו ומעשינו.",
      prideFruits: "פירות הגאווה: פילוג, שנאה, פחד, שליטה, מלחמה.",
      prideFruitsList: "רוח מפלגתית: \"אני צודק, נקודה\"|פוליטיקה של גאווה: \"אני צודק לפגוע בך\"|שימוש בכתובים כדי לפגוע (תהליך ערמומי)|שנאת אנשים (לא רק מעשים)|מנהיגים רוחניים המסתירים את סטייתם ואי-יושרם|שתיקה שותפה למעשה מול עוול|פילוג ומלחמות|שנאה המתחפשת לאדיקות|גניבה והרס|מניפולציה למען גאווה|בוז ואלימות",
      
      godFruits: "פירות אלוהים: אהבה, שלום, סבלנות, חמלה, אחדות.",
      godFruitsList: "הפרדת מעשים מהאדם בחוכמה|רחמים על עוניינו האנושי|חסד תוך הגנה על עצמנו לפי ההקשרים|חשיפת עוול כדי להגן על אחרים|אמירת האמת באומץ|שלום לכולם|אהבה ללא הבחנה|פיוס ואחדות|ענווה וכבוד|חופש לכולם",
      
      finalQuote: "אם רוצים לראות את פני אלוהים, תסתכל על פניו של הזולת.",
      author: "- עמנואל"
    },
    footer: {
      quote: "האהבה מנצחת תמיד, והאמת מאחדת אותנו.",
      author: "- עמנואל"
    }
};

export default unityTranslations;
